(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ibg-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ibg-responsive-hero-video')) {
    customElements.define('ibg-responsive-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 740px)');
        this.onDeviceChange = this.selectVideo.bind(this);
        this.mediaQuery.addEventListener('change', this.onDeviceChange);
        this.frame = requestAnimationFrame(this.onDeviceChange);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.mediaQuery?.removeEventListener('change', this.onDeviceChange);
        this.stopVideo();
        this.activeTemplate = null;
      }

      selectVideo() {
        const device = this.mediaQuery.matches ? 'mobile' : 'desktop';
        const template = this.querySelector(`template[data-device="${device}"]`) || this.querySelector('template[data-device="desktop"]');
        if (!template || template === this.activeTemplate) return;

        this.stopVideo();
        this.activeTemplate = template;
        this.video = template.content.firstElementChild.cloneNode(true);
        this.video.muted = true;
        this.video.addEventListener('playing', () => this.querySelector('.ibg-hero__poster')?.remove(), { once: true });
        this.appendChild(this.video);
        this.video.play().catch(() => {});
      }

      stopVideo() {
        if (!this.video) return;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video.remove();
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
